import React from "react";
import AboutSection from "../AboutPage/AboutSection";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import ContactForm from "./ContactForm";
import "./contact.css";

const contactdetails = [
  {
    icon: faMapMarkerAlt,
    content:
      "Ground Floor, Subramaniam Arcade, Gosaikunnu, Kuriachira p.o, Near Srivari Honda Showroom, Thrissur - 680006, Kerala, India",
    link: "https://maps.app.goo.gl/H1JQSCsPvREZVPb29",
    target: "_blank",
  },
  {
    icon: faEnvelope,
    link: "mailto:accfabgoldjewellery@gmail.com",
    content: "accfabgoldjewellery@gmail.com",
  },
  {
    icon: faPhone,
    link: "tel:+917012065100",
    content: "70120 65100",
  },
];
const bg2 = "../images/bg/bg2.webp";

const Contact = () => {
  const phoneNumber = "7012065100";

  const message = "Hello, I am interested in your services!";

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;
  return (
    <>
      <AboutSection data="CONTACT" backgroundImage={bg2} />
      <div className="w-full flex lg:flex-row md:flex-col sm:flex-col max-sm:flex-col">
        <div class="lg:w-1/2 md:w-[100%] max-sm:w-full p-7">
          <iframe
            className="w-full md:h-[800px] max-sm:w-full"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d932.199963848604!2d76.22255614649015!3d10.50840310724893!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7ee32be8033fb%3A0xb2a951e2c77e0e93!2sSubramaniam%20Arcade!5e1!3m2!1sen!2sin!4v1752836279118!5m2!1sen!2sin"
            title="Google Maps Location"
          ></iframe>
        </div>
        <div className="md:w-[100%] lg:w-[50%] max-sm:w-full">
          <div className="flex lg:flex-row md:flex-row max-sm:flex-col pt-[78px] max-sm:p-[20px] md:pl-[115px] mb-[44px]">
            <div id="contact" className="md:w-1/2 max-sm:w-full">
              <h3 className="text-[20px] leading-[30px] text-tertary2 font-bold tracking-[3px] uppercase mb-[28px]">
                contact detail
              </h3>
              <ul class="pl-1 opacity-50 mb-[11px]">
                {contactdetails.map((data) => (
                  <li className="text-[18px] leading-[18px] block mb-5 text-black">
                    <i className="text-[21px] mr-[29px]">
                      <FontAwesomeIcon icon={data.icon} />{" "}
                    </i>
                    <a
                      href={data.link}
                      target={data.target}
                      className="mt-1 font-normal text-base hover:text-tertary2 cursor-pointer"
                    >
                      {data.content}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <ContactForm />
        </div>
        <div className="whatsapp-icon fixed bottom-10 right-10 bg-green-500 text-white p-3 rounded-full cursor-pointer animate-vibrate z-50">
          <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
            {" "}
            <FontAwesomeIcon icon={faWhatsapp} className="text-lg" />{" "}
          </a>
        </div>
      </div>
    </>
  );
};

export default Contact;
